(function () {
    'use strict';

    angular.module('doclr.components.validations', [])
        .directive('alphaNumericValidation', () => ({
            require: 'ngModel',
            restrict: 'A',
            link: (scope, elem, attr, ngModel) => {
                let validator = (value) => {
                    if (/^[a-zA-Z0-9]*$/.test(value)) {
                        ngModel.$setValidity('alphanumeric', true);
                        return value;
                    } else {
                        ngModel.$setValidity('alphanumeric', false);
                        return undefined;
                    }
                };
                ngModel.$parsers.unshift(validator);
                ngModel.$formatters.unshift(validator);
            }
        }))
        .directive('assertAfter', () => ({
            require: 'ngModel',
            link: function (scope, elm, attrs, ngModelCtrl) {
                var uurRegex = /^([01]\d|2[0-3]):([0-5]\d)$/;

                scope.$watch(attrs.assertAfter, function (newValue, oldValue) {
                    if (newValue !== oldValue) {
                        updateUur(newValue);
                    }
                });

                function updateUur(newValue) {
                    var before = moment(newValue, 'HH:mm');
                    var current = moment(ngModelCtrl.$modelValue, 'HH:mm');
                    if (uurRegex.test(newValue) && before.isValid() && uurRegex.test(ngModelCtrl.$modelValue) && current.isValid() && before.isAfter(current)) {
                        ngModelCtrl.$setViewValue(newValue);
                        ngModelCtrl.$render();
                    }
                }

                scope.$watch(attrs.assertAfter, function (newValue, oldValue) {
                    if (newValue !== oldValue) {
                        updateUur(newValue);
                    }
                });

            }
        }))
        .directive('assertBefore', () => ({
            require: 'ngModel',
            link: function (scope, elm, attrs, ngModelCtrl) {
                var uurRegex = /^([01]\d|2[0-3]):([0-5]\d)$/;

                function updateUur(newValue) {
                    var after = moment(newValue, 'HH:mm');
                    var current = moment(ngModelCtrl.$modelValue, 'HH:mm');
                    if (uurRegex.test(newValue) && after.isValid() && uurRegex.test(ngModelCtrl.$modelValue) && current.isValid() && after.isBefore(current)) {
                        ngModelCtrl.$setViewValue(newValue);
                        ngModelCtrl.$render();
                    }
                }

                scope.$watch(attrs.assertBefore, function (newValue, oldValue) {
                    if (newValue !== oldValue) {
                        updateUur(newValue);
                    }
                });
            }
        }))
        .directive('checkEmailValidation', ['$http', 'praktijkContext', ($http, praktijkContext) => ({
            require: 'ngModel',
            link: function (scope, elem, attrs, ctrl) {
                elem.on('blur', function () {
                    scope.$apply(function () {
                        if (!praktijkContext.patientenstopZonderLogin) {
                            return;
                        }
                        $http({
                            method: 'POST',
                            url: '/api/public/patient/emailvalidatie',
                            data: {
                                praktijk_id: praktijkContext.id,
                                email: elem.val()
                            }
                        }).then(function (response) {
                            ctrl.$setValidity('emailNietGeaccepteerd', response.data);
                            ctrl.emailGeinvalideerd = false;
                        });
                    });
                });
                elem.on('keyup', function () {
                    if (!praktijkContext.patientenstopZonderLogin) {
                        return;
                    }
                    ctrl.emailGeinvalideerd = true;
                    ctrl.$setValidity('emailNietGeaccepteerd', true);
                });
            }
        })])
        .directive('dateTimeInterval', () => ({
            scope: {
                model: '=ngModel'
            },
            replace: true,
            /*jshint multistr: true */
            template: '<div>\
                                <div>\
                                    <span style="white-space: nowrap">\
                                        <input ng-model="model.dagVan" class="form-control form-control-inline" jqdatepicker-input doclr-date type="text" class="dagVan" ng-blur="updateTot()">\
                                        <input ng-model="model.uurVan" class="form-control form-control-inline input-short" type="text" class="uurVan" ng-blur="updateTot()" required hhmm-pattern ng-disabled="model.heleDag">\
                                    </span>\
                                    <span class="form-text-inline">{{"partials.adminagenda.afspraaktdetail.labelTimeBetween" | translate}}</span>\
                                    <span style="white-space: nowrap">\
                                        <input ng-model="model.dagTot" class="form-control form-control-inline" jqdatepicker-input doclr-date type="text" class="dagTot" ng-blur="updateVan()">\
                                        <input ng-model="model.uurTot" class="form-control form-control-inline input-short" type="text" class="uurTot" ng-blur="updateVan()" required hhmm-pattern ng-disabled="model.heleDag">\
                                    </span>\
                                </div>\
                                <div class="checkbox">\
                                    <label style="font-weight: normal" ><input type="checkbox" ng-model="model.heleDag"> {{"validation.day" | translate}}</label>\
                                </div>\
                            </div>',
            link: function (scope) {
                function momentVan() {
                    return moment(scope.model.dagVan + ' ' + scope.model.uurVan);
                }

                function momentTot() {
                    return moment(scope.model.dagTot + ' ' + scope.model.uurTot);
                }

                scope.updateTot = function () {
                    var van = momentVan();
                    var tot = momentTot();
                    if (van.isValid() && tot.isValid() && van.isAfter(tot)) {
                        scope.model.dagTot = scope.model.dagVan;
                        scope.model.uurTot = scope.model.uurVan;
                    }
                };

                scope.updateVan = function () {
                    var van = momentVan();
                    var tot = momentTot();
                    if (van.isValid() && tot.isValid() && tot.isBefore(van)) {
                        scope.model.dagVan = scope.model.dagTot;
                        scope.model.uurVan = scope.model.uurTot;
                    }
                };

            }
        }))
        .directive('doclrDate', () => ({
            require: 'ngModel',
            link: function (scope, elm, attrs, ngModelCtrl) {
                var dateTransformer = function (fromFormat, toFormat) {
                    return function (value) {
                        if (!value) {
                            ngModelCtrl.$setValidity('date', true);
                            return value;
                        }

                        var date = moment(value, fromFormat);
                        var valid = date.isValid() && date.isAfter(moment('1850', 'YYYY'));
                        ngModelCtrl.$setValidity('date', valid);
                        return valid ? date.format(toFormat) : undefined;
                    };
                };

                ngModelCtrl.$parsers.push(dateTransformer('DD-MM-YYYY', 'YYYY-MM-DD'));
                ngModelCtrl.$formatters.push(dateTransformer('YYYY-MM-DD', 'DD-MM-YYYY'));

                elm.bind('keyup', function (evt) {
                    if (evt.keyCode === 8) {
                        return;
                    }

                    var value = elm.val();
                    var numChars = value.length;
                    if (numChars === 2 || numChars === 5) {
                        value = value + '-';
                        elm.val(value);
                    }
                });
            }
        }))
        .directive('doclrGuid', () => ({
            require: 'ngModel',
            link: function (scope, elm, attrs, ngModelCtrl) {
                elm.bind('keyup', function (evt) {
                    if (evt.keyCode === 8) {
                        return;
                    }
                    updateValue();
                });

                elm.bind('paste', function () {
                    window.setTimeout(function () {
                        updateValue();
                    }, 20);
                });


                function updateValue() {
                    var value = elm.val();

                    if (!value) {
                        return;
                    }

                    //Enkel alphanumeric
                    value = value.replace(/[\W_]/g, '');

                    value = addCharAt(value, '-', 8);
                    value = addCharAt(value, '-', 13);
                    value = addCharAt(value, '-', 18);
                    value = addCharAt(value, '-', 23);

                    elm.val(value);
                    ngModelCtrl.$setViewValue(value);
                }
            }
        }))
        .directive('doclrPcrCode', () => ({
            require: 'ngModel',
            link: function (scope, elm, attrs, ngModelCtrl) {
                elm.bind('keyup', function (evt) {
                    if (evt.keyCode === 8) {
                        return;
                    }
                    updateValue();
                });

                elm.bind('paste', function () {
                    window.setTimeout(function () {
                        updateValue();
                    }, 20);
                });


                function updateValue() {
                    var value = elm.val();

                    if (!value) {
                        return;
                    }

                    //Enkel alphanumeric
                    value = value.replace(/[\W_]/g, '');

                    value = addCharAt(value, '-', 4);
                    value = addCharAt(value, '-', 9);
                    value = addCharAt(value, '-', 14);

                    elm.val(value);
                    ngModelCtrl.$setViewValue(value);
                }
            }
        }))
        .directive('doclrRijksregisternummer', () => ({
            require: 'ngModel',
            link: function (scope, elm, attrs, ngModelCtrl) {

                var validateRijksregisterNummer = function (n) {

                    if (!n) {
                        return false;
                    }

                    n = n.replace(/[^\d]/g, '');
                    // insz numbers needs to be 11 chars long
                    if (n.length !== 11) {
                        return false;
                    }

                    var checkDigit = parseInt(n.substr(n.length - 2, 2));
                    var modFunction = function (nr) {
                        return 97 - (nr % 97);
                    };

                    var nrToCheck = parseInt(n.substr(0, 9));

                    // first check without 2 (voor 2000)
                    if (modFunction(nrToCheck) === checkDigit) {
                        return true;
                    }

                    // then check with 2 appended for y2k+ births (na 2000)
                    nrToCheck = parseInt('2' + n.substr(0, 9));

                    return (modFunction(nrToCheck) === checkDigit);
                };

                elm.bind('keyup', function (evt) {
                    if (evt.keyCode === 8) {
                        return;
                    }

                    updateValue();
                });

                function updateValue() {
                    window.setTimeout(function () {
                        var value = elm.val();
                        if (!value) {
                            return;
                        }

                        //Enkel nummers
                        var newValue = value.replace(/[^\d]/g, '');

                        newValue = addCharAt(newValue, '.', 2);
                        newValue = addCharAt(newValue, '.', 5);
                        newValue = addCharAt(newValue, '-', 8);
                        newValue = addCharAt(newValue, '.', 12);

                        if (newValue !== value) {
                            elm.val(newValue);
                            ngModelCtrl.$setViewValue(newValue);
                        }
                    }, 2);

                }

                //For DOM -> model validation
                ngModelCtrl.$parsers.unshift(function (rijksregisterNummer) {
                    if (!rijksregisterNummer) {
                        if (!ngModelCtrl.$$attr.required) {
                            ngModelCtrl.$setValidity('mod97', true);
                        }
                        return rijksregisterNummer;
                    }
                    var valid = validateRijksregisterNummer(rijksregisterNummer);
                    updateValue();
                    ngModelCtrl.$setValidity('mod97', valid);
                    return valid ? rijksregisterNummer : undefined;
                });

                //For model -> DOM validation
                ngModelCtrl.$formatters.unshift(function (rijksregisterNummer) {
                    if (!rijksregisterNummer) {
                        return rijksregisterNummer;
                    }
                    var valid = validateRijksregisterNummer(rijksregisterNummer);
                    updateValue();
                    ngModelCtrl.$setValidity('mod97', valid);
                    return valid ? rijksregisterNummer : undefined;
                });
            }
        }))
        .directive('doclrRijksregisternummerSanitizer', () => ({
            require: 'ngModel',
            scope: {
                doclrAfterRijksregisternummerSanitize: '&'
            },
            link: function (scope, elm, attrs, ngModelCtrl) {

                elm.bind('keyup', function (evt) {
                    if (evt.keyCode === 8) {
                        return;
                    }
                    updateValue();
                });

                function updateValue() {
                    window.setTimeout(() => {
                        const value = elm.val();
                        if (!window.doclrSsinUtils.isUnformattedSsin(value)) {
                            return;
                        }

                        window.setTimeout(()=>{
                            const value = elm.val();

                            if (!window.doclrSsinUtils.isUnformattedSsin(value) ) {
                                return;
                            }

                            const ssin = window.doclrSsinUtils.getSsin(value);

                            elm.val(ssin);
                            ngModelCtrl.$setViewValue(ssin);
                            if(scope.doclrAfterRijksregisternummerSanitize){
                                scope.doclrAfterRijksregisternummerSanitize();
                            }

                        }, 75);


                    }, 2);
                }
            }
        }))
        .directive('doclrTelefoon', () => ({
            require: 'ngModel',
            link: function (scope, elm, attrs, ngModelCtrl) {

                const valideerTelefoon = function (telefoonnummer) {

                    if (!telefoonnummer && telefoonnummer !== '0') {
                        ngModelCtrl.$setValidity('telefoonFormaat', true);
                        return true;
                    }

                    //Bevat iets anders dan + , nummers en spaties
                    if (!(/^(\+)?[0-9\s]+$/.test(telefoonnummer))) {
                        ngModelCtrl.$setValidity('telefoonFormaat', false);
                        return false;
                    }

                    let cleanNumber = telefoonnummer.replace(/[^\d]/g, '');
                    if (telefoonnummer.startsWith('+')) {
                        cleanNumber = '+' + cleanNumber;
                    }

                    if (cleanNumber.length < 9 || cleanNumber.length > 20) {
                        ngModelCtrl.$setValidity('telefoonFormaat', false);
                        return false;
                    }

                    //https://manual.limesurvey.org/Using_regular_expressions/nl#Belgisch_telefoonnummer
                    if (/^((\+|00)32\s?|0)(\d\s?\d{3}|\d{2}\s?\d{2})(\s?\d{2}){2}$/.test(cleanNumber)) {
                        ngModelCtrl.$setValidity('telefoonFormaat', true);
                        return true;
                    }

                    if (/^((\+|00)32\s?|0)4([56789]\d)(\s?\d{2}){3}$/.test(cleanNumber)) {
                        ngModelCtrl.$setValidity('telefoonFormaat', true);
                        return true;
                    }

                    const countryCodes = ['0093', '00355', '00213', '00376', '00244', '00672', '0054', '00374', '00297', '0061', '0043', '00994', '00973', '00880', '00375', '00501', '00229', '00975', '00591', '00387', '00267', '0047', '0055', '00246', '00673', '00359', '00226', '00257', '00855', '00237', '00238', '00599', '00236', '00235', '0056', '0086', '0061', '0061', '0057', '00269', '00242', '00243', '00682', '00506', '00385', '0053', '00599', '00357', '00420', '00225', '0045', '00253', '00593', '0020', '00503', '00240', '00291', '00372', '00251', '00500', '00298', '00679', '00358', '0033', '00594', '00689', '00262', '00241', '00220', '00995', '0049', '00233', '00350', '0030', '00299', '00590', '00502', '0044', '00224', '00245', '00592', '00509', '00672', '00504', '00852', '0036', '00354', '0091', '0062', '0098', '00964', '00353', '0044', '00972', '0039', '0081', '0044', '00962', '00254', '00686', '00965', '00996', '00856', '00371', '00961', '00266', '00231', '00218', '00423', '00370', '00352', '00853', '00389', '00261', '00265', '0060', '00960', '00223', '00356', '00692', '00596', '00222', '00230', '00262', '0052', '00691', '00373', '00377', '00976', '00382', '00212', '00258', '0095', '00264', '00674', '00977', '0031', '00687', '0064', '00505', '00227', '00234', '00683', '00672', '00850', '0047', '00968', '0092', '00680', '00970', '00507', '00675', '00595', '0051', '0063', '00870', '0048', '00351', '00974', '0040', '00250', '00262', '00685', '00378', '00966', '00221', '00381', '00248', '00232', '0065', '00421', '00386', '00677', '00252', '0027', '00500', '0082', '00211', '0034', '0094', '00590', '00290', '00590', '00508', '00249', '00597', '0047', '00268', '0046', '0041', '00963', '00239', '00886', '00992', '00255', '0066', '00670', '00228', '00690', '00676', '00216', '0090', '00993', '00688', '0044', '00256', '00380', '00971', '00598', '00998', '00678', '0058', '0084', '00681', '00212', '00967', '00260', '00263', '00358', '+93', '+355', '+213', '+376', '+244', '+672', '+54', '+374', '+297', '+61', '+43', '+994', '+973', '+880', '+375', '+501', '+229', '+975', '+591', '+387', '+267', '+47', '+55', '+246', '+673', '+359', '+226', '+257', '+855', '+237', '+238', '+599', '+236', '+235', '+56', '+86', '+61', '+61', '+57', '+269', '+242', '+243', '+682', '+506', '+385', '+53', '+599', '+357', '+420', '+225', '+45', '+253', '+593', '+20', '+503', '+240', '+291', '+372', '+251', '+500', '+298', '+679', '+358', '+33', '+594', '+689', '+262', '+241', '+220', '+995', '+49', '+233', '+350', '+30', '+299', '+590', '+502', '+44', '+224', '+245', '+592', '+509', '+672', '+504', '+852', '+36', '+354', '+91', '+62', '+98', '+964', '+353', '+44', '+972', '+39', '+81', '+44', '+962', '+254', '+686', '+965', '+996', '+856', '+371', '+961', '+266', '+231', '+218', '+423', '+370', '+352', '+853', '+389', '+261', '+265', '+60', '+960', '+223', '+356', '+692', '+596', '+222', '+230', '+262', '+52', '+691', '+373', '+377', '+976', '+382', '+212', '+258', '+95', '+264', '+674', '+977', '+31', '+687', '+64', '+505', '+227', '+234', '+683', '+672', '+850', '+47', '+968', '+92', '+680', '+970', '+507', '+675', '+595', '+51', '+63', '+870', '+48', '+351', '+974', '+40', '+250', '+262', '+685', '+378', '+966', '+221', '+381', '+248', '+232', '+65', '+421', '+386', '+677', '+252', '+27', '+500', '+82', '+211', '+34', '+94', '+590', '+290', '+590', '+508', '+249', '+597', '+47', '+268', '+46', '+41', '+963', '+239', '+886', '+992', '+255', '+66', '+670', '+228', '+690', '+676', '+216', '+90', '+993', '+688', '+44', '+256', '+380', '+971', '+598', '+998', '+678', '+58', '+84', '+681', '+212', '+967', '+260', '+263', '+358'];

                    for (let i = 0; i < countryCodes.length; i++) {
                        if (cleanNumber.startsWith(countryCodes[i])) {
                            ngModelCtrl.$setValidity('telefoonFormaat', true);
                            return true;
                        }
                    }

                    ngModelCtrl.$setValidity('telefoonFormaat', false);
                    return false;
                };

                //For DOM -> model validation
                ngModelCtrl.$parsers.unshift(function (telefoonnummer) {
                    var valid = valideerTelefoon(telefoonnummer);
                    return valid ? telefoonnummer : undefined;
                });

                //For model -> DOM validation
                ngModelCtrl.$formatters.unshift(function (telefoonnummer) {
                    var valid = valideerTelefoon(telefoonnummer);
                    return valid ? telefoonnummer : undefined;
                });
            }
        }))
        .directive('hhmmPattern', () => ({
            require: 'ngModel',
            link: function (scope, elm, attrs, ngModelCtrl) {
                var uurRegex = /^([01]\d|2[0-3]):([0-5]\d)$/;

                var validate = function (value) {
                    if (value === null || value === '' || typeof (value) === 'undefined') {
                        ngModelCtrl.$setValidity('hhmmPattern', true);
                        return value;
                    }

                    if (uurRegex.test(value)) {
                        ngModelCtrl.$setValidity('hhmmPattern', true);
                        return value;
                    } else {
                        ngModelCtrl.$setValidity('hhmmPattern', false);
                        return undefined;
                    }
                };

                var interpret = function (newValue) {
                    if (!newValue || uurRegex.test(newValue)) {
                        return newValue;
                    }
                    var number = parseInt(newValue.replace(/\D/g, ''), 10);
                    var padded = '' + number;
                    if (number < 10) {
                        padded = '0' + number + '00';
                    } else if (number < 24) {
                        padded = number + '00';
                    } else if (number < 100) {
                        padded = '0' + number + '0';
                    } else if (number < 1000) {
                        padded = '0' + number;
                    }
                    return padded.slice(0, 2) + ':' + padded.slice(2, 4);
                };

                elm.bind('blur', function () {
                    scope.$apply(function () {
                        var input = interpret(elm.val());
                        validate(input);
                        ngModelCtrl.$setViewValue(input);
                        ngModelCtrl.$render();
                    });
                });

                elm.bind('keyup change', function () {
                    scope.$apply(function () {
                        validate(elm.val());
                    });
                });

                scope.$on('$destroy', function () {
                    elm.off();
                });

                ngModelCtrl.$formatters.push(validate, interpret);
            }
        }))
        .directive('lotnumberValidation', ['Lotnummer', (Lotnummer) => ({
            require: 'ngModel',
            restrict: 'A',
            link: (scope, elem, attr, ngModel) => {
                let activeLotnumbers = [];
                let myControl = ngModel;

                let validator = (value) => {
                    if (activeLotnumbers.length <= 0) {
                        ngModel.$setValidity('lotnumber', true);
                        return value;
                    }

                    let matchingLotnumber = activeLotnumbers.find((lotnr) => {
                        const sameNumber = lotnr.lotNumber === value;
                        const sameType = !attr.lotnumberValidation || lotnr.vaccinType.code === attr.lotnumberValidation;
                        return sameNumber && sameType;
                    });

                    if (matchingLotnumber) {
                        ngModel.$setValidity('lotnumber', attr.lotnumberValidation ? (attr.lotnumberValidation === matchingLotnumber.vaccinType.code) : true);
                        return value;
                    } else {
                        ngModel.$setValidity('lotnumber', false);
                        return undefined;
                    }
                };

                Lotnummer.getAllActive().then(res => {
                    activeLotnumbers = res;
                    myControl.$setDirty();
                    validator(myControl.$modelValue);
                });

                ngModel.$parsers.unshift(validator);
                ngModel.$formatters.unshift(validator);
            }
        })])
        .directive('preFilledValidation', () => ({
            restrict: 'A',
            require: 'ngModel',
            link: function (scope, elm, attrs, ctrl) {
                ctrl.$validators.prefilled_require = (modelValue, viewValue) => {
                    var isValid = (viewValue && modelValue);
                    ctrl.$setValidity('prefilled_require', isValid);
                    ctrl.$setDirty();
                    return isValid;
                };
            }
        }))
        .directive('tokenStrength', () => ({
            require: 'ngModel',
            link: function (scope, elm, attrs, ngModelCtrl) {

                var validateToken = function (token) {
                    var isValid = true;
                    if (token.length >= 6) {
                        ngModelCtrl.$setValidity('tokenLengte', true);
                    } else {
                        ngModelCtrl.$setValidity('tokenLengte', false);
                        isValid = false;
                    }

                    if (/\d/.test(token)) {
                        ngModelCtrl.$setValidity('tokenNummer', true);
                    } else {
                        ngModelCtrl.$setValidity('tokenNummer', false);
                        isValid = false;
                    }

                    if (/[a-z]/.test(token)) {
                        ngModelCtrl.$setValidity('tokenKleineLetter', true);
                    } else {
                        ngModelCtrl.$setValidity('tokenKleineLetter', false);
                        isValid = false;
                    }

                    if (/[A-Z]/.test(token)) {
                        ngModelCtrl.$setValidity('tokenGroteLetter', true);
                    } else {
                        ngModelCtrl.$setValidity('tokenGroteLetter', false);
                        isValid = false;
                    }

                    if (!/[^a-zA-Z0-9-._~]/.test(token)) {
                        ngModelCtrl.$setValidity('tokenSpecialeLetters', true);
                    } else {
                        ngModelCtrl.$setValidity('tokenSpecialeLetters', false);
                        isValid = false;
                    }

                    return isValid;
                };

                //For DOM -> model validation
                ngModelCtrl.$parsers.unshift(function (token) {
                    var valid = validateToken(token);
                    return valid ? token : undefined;
                });

                //For model -> DOM validation
                ngModelCtrl.$formatters.unshift(function (token) {
                    var valid = validateToken(token);
                    return valid ? token : undefined;
                });
            }
        }))
    ;

    function addCharAt(str, chara, at) {
        if (str.length >= at) {
            return [str.slice(0, at), chara, str.slice(at)].join('');
        }
        return str;
    }
})();
